export default {
    checkIfExist(from, compareWith) {
        return from.filter(fromEl => compareWith.includes(fromEl));
    },
    arrayDiff(from, to) {
        return from.filter(el => {
            return to.indexOf(el) === -1;
        });
    },
    getParent(tree, value) {
        const itemFound = this.recursiveSearch(tree, value, true);
        return itemFound;
    },
    getNode(tree, value) {
        const itemFound = this.recursiveSearch(tree, value, false);
        return itemFound;
    },
    checkIfChildrenIsSelected(childrens, selectedValues) {
        for (let i = 0; i < childrens.length; i++) {
            const branch = childrens[i];

            if (selectedValues.includes(branch.value)) {
                return true;
            }
        }

        return false;
    },
    validateTree(tree, selectedValues) {
        if (tree) {
            tree.forEach(b => {
                if (b.children && b.children.length) {
                    if (this.checkIfChildrenIsSelected(b.children, selectedValues)) {
                        b.isValid = true;
                    } else {
                        b.isValid = false;
                    }

                    this.validateTree(b.children, selectedValues);
                }
            });
        }

        return tree;
    },
    recursiveSearch(tree, value, getParent) {
        for (let i = 0; i < tree.length; i++) {
            const branch = tree[i];

            let foundElement;

            if (branch.children) {
                foundElement = branch.children.find(el => el.value === value);
            }

            if (foundElement) {
                if (getParent) {
                    return branch;
                } else {
                    return foundElement;
                }
            } else {
                if (branch.children) {
                    foundElement = this.recursiveSearch(branch.children, value, getParent);

                    if (foundElement) {
                        return foundElement;
                    }
                }
            }
        }
    }
}